export const canUseDOM = !!(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);

/*
 * Browsers that block site data (Safari "Block All Cookies", some Android
 * WebViews, in-app browsers) throw SecurityError on merely *touching*
 * window.sessionStorage or window.localStorage. Every read and write goes
 * through these so a blocked-storage visitor cannot take a component
 * constructor down with it.
 */
const safeGet = (storageName) => (key) => {
  try {
    return canUseDOM && window[storageName] ? window[storageName].getItem(key) : null;
  } catch (e) {
    return null; // storage blocked; the value is non-essential
  }
};

const safeSet = (storageName) => (key, value) => {
  try {
    if (canUseDOM && window[storageName]) window[storageName].setItem(key, value);
  } catch (e) { /* storage blocked or quota exceeded; the value is non-essential */ }
};

export const safeSessionGet = safeGet('sessionStorage');
export const safeSessionSet = safeSet('sessionStorage');
export const safeLocalGet = safeGet('localStorage');
export const safeLocalSet = safeSet('localStorage');
